import { motion } from "framer-motion";

import useSidebar from "./useSidebar";
import { sidebarVariants } from "./variants";
import { MenuToggle, Navigation } from "./components";
import "./styles.scss";
import TopBar from "../infoTopBar";

const Sidebar = () => {
  const { isOpen, height, containerRef, toggleOpen, clickAwayRef } =
    useSidebar();

  return (
    <motion.aside
      initial={false}
      animate={isOpen ? "open" : "closed"}
      custom={height}
      ref={containerRef}
      className={`sidebar ${isOpen ? "open" : "closed"}`}
    >
      <motion.div
        className="sidebar-background"
        variants={sidebarVariants}
        ref={clickAwayRef}
      />
      <Navigation />
      <TopBar isInSidebar isOpen={isOpen}/>
      <MenuToggle toggle={() => toggleOpen()} isOpen={isOpen} />
    </motion.aside>
  );
};

export default Sidebar;
